import { createQueryKeys } from '@lukemorales/query-key-factory';

export const uaeAdmin = createQueryKeys('uaeAdmin', {
  queue: (scope: string, queue: string, params: Record<string, string>) => [scope, queue, params],
  card: (agentProfileId: string) => [agentProfileId],
  marketPreview: (agentProfileId: string) => [agentProfileId],
  agents: (params: Record<string, string | string[]>) => [params],
  settings: null,
  managers: null,
});
